// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {
        document.body.classList.add("is-touch");
        return true;
    }() : function () {
        document.body.classList.add("is-desktop");
        return false;
    }(),
    body: $("body"),
    mobile: 768,
    phablet: 1024,
    tablet: 1200
};

// initalize dropdown
export function dropdown() {

    $(".js-drop-trigger").on("click", function (e) {
        let $thisDrop = $(this).closest(".js-drop");
        $(".js-drop").not($thisDrop).removeClass("is-open");
        $thisDrop.toggleClass("is-open");
        e.preventDefault();
    });
    $(document).on("click", function (e) {
        let isOpen = false;
        isOpen = $(this).hasClass("is-open");
        if (isOpen) {
            let $drop = !!$(e.target).closest(".js-drop").length;
            if (!$drop) {
                $(".js-drop").removeClass("is-open");
                isOpen = false;
            }
        }
    });
}

// init accordion
export function accordion() {
    let $customNav = $(".js-accordion.js-custom-nav").children("ul");
    let $childsItems = $customNav.children(".menu-item-has-children");
    $childsItems.addClass("js-accordion-item");
    $childsItems.children(".sub-menu").addClass("js-accordion-content");
    $childsItems.children("a").each((index, item) => {
        $(item).addClass("js-accordion-trigger").append("<span class='nav-custom-trigger js-arrow-trigger'></span>");
    });
    $(".js-accordion-trigger").on("click", (e) => {
        let $self = $(e.target);
        let $container = $self.closest(".js-accordion");
        let $customNav = $container.hasClass("js-custom-nav");
        let $currentItem = $self.closest(".js-accordion-item");
        let isInnerArrow = !!$(e.target).closest(".js-arrow-trigger").length;
        let $currentContent = !isInnerArrow ? $self.siblings(".js-accordion-content") : $self.closest(".js-accordion-trigger").siblings(".js-accordion-content");
        let $allItems = $container.find(".js-accordion-item");
        let $allContents = $container.find(".js-accordion-content");
        let isMob = $self.closest(".js-accordion").hasClass("js-accordion-mob");
        let isInnerLink = !!$(e.target).closest(".js-inner-link").length;

        function actions() {
            $currentItem.toggleClass("is-open");
            $allItems.not($currentItem).removeClass("is-open");
            $allContents.not($currentContent).slideUp(function () {
                $(this).removeClass("is-opened");
                $(this).css("display", "");
            });
            $currentContent.slideToggle(function () {
                $(this).toggleClass("is-opened");
                $(this).css("display", "");
                if ($customNav) {
                    $.scrollify.update();
                }
            });
            e.preventDefault();
        }

        if (window.innerWidth < this.phablet && isMob) {
            actions();
        } else if (!isMob && isInnerArrow) {
            actions();
        } else if (!isMob && !$customNav && !isInnerLink) {
            actions();
        }
    });
}

// Add class to main tag if banner does not exist
export function mainClass() {
    let isIntroSection = $(".intro").length;
    let isSideBarLength = $(".content-main").length;
    let isErrorBlock = $(".error-block").length;
    if (!isIntroSection && !isErrorBlock) {
        $("main").addClass("main-without-banner");
    }
    if (isSideBarLength) {
        $(".wrapper").addClass("wrapper-with-sidemenu");
    }
}


// Form states
export function formStates() {
    let $contactBlock = $(".contacts-block");
    let $fields = $contactBlock.find("input, select, textarea");

    $fields.on("focus", function() {
        $(this).parent().addClass("is-hover");
    });
    $fields.on("focusout", function() {
        $(this).parent().removeClass("is-hover");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/module.js